import { defineMessages } from 'react-intl'

export const scope = 'app.components.ClientVCheckTable'

/*
 * ClientVCheckTable Messages
 *
 * This contains all the text for the ClientVCheckTable component.
 */
export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the ClientVCheckTable component!',
  },
  tableHeaderOne: {
    id: `${scope}.tableHeaderOne`,
    defaultMessage: 'Scheduled',
  },
  tableHeaderTwo: {
    id: `${scope}.tableHeaderTwo`,
    defaultMessage: 'Completed',
  },
  tableHeaderThree: {
    id: `${scope}.tableHeaderThree`,
    defaultMessage: 'Check in',
  },
  tableHeaderFour: {
    id: `${scope}.tableHeaderFour`,
    defaultMessage: 'Type',
  },
  tableHeaderFive: {
    id: `${scope}.tableHeaderFive`,
    defaultMessage: 'BrAC Result',
  },
  tableHeaderSix: {
    id: `${scope}.tableHeaderSix`,
    defaultMessage: 'Status',
  },
  tableHeaderSeven: {
    id: `${scope}.tableHeaderSeven`,
    defaultMessage: 'Location',
  },
  tableHeaderEight: {
    id: `${scope}.tableHeaderEight`,
    defaultMessage: 'Reviewed On',
  },
  tableHeaderNine: {
    id: `${scope}.tableHeaderNine`,
    defaultMessage: 'Reviewed By',
  },
  tableHeaderTen: {
    id: `${scope}.tableHeaderTen`,
    defaultMessage: 'Review',
  },
  tableHeaderEleven: {
    id: `${scope}.tableHeaderEleven`,
    defaultMessage: 'Facial Rec Status',
  },
  tableHeaderTwelve: {
    id: `${scope}.tableHeaderTwelve`,
    defaultMessage: 'Serial Number',
  },
})
